export const SET_DOCUMENT = 'SET_DOCUMENT'
export const RESET_DOCUMENT = 'RESET_DOCUMENT'
export const SET_DOCUMENT_LIST = 'SET_DOCUMENT_LIST';
export const RESET_DOCUMENT_LIST = 'RESET_DOCUMENT_LIST';